<div class="mat-dialog-container">
	<h2 mat-dialog-title>{{ "ORDER_BASKET.MATERIAL_PREVIEW_DIALOG.TITLE" | translate }}{{ materialPreview.orderId }}_{{ materialPreview.orderAdDetail.materialId }}</h2>
	<p class="mat-dialog-subtitle">{{ materialPreview.orderAdDetail.materialDeadline | cassTimestamp }}</p>
	<mat-divider></mat-divider>
	<div mat-dialog-content>
		<ng-container *ngIf='!isUploading && !imagePreviewUrl'>
			<cass-upload-material [uploadProgress]="fileUploadProgress"
								  [isProcessing]="isProcessing"
								  (uploadFile)="uploadMaterial($event)"
								  (findMaterialClickEvent)="openFindMaterialDialog($event)"></cass-upload-material>
		</ng-container>
		<div class="image-container" *ngIf="!!imagePreviewUrl && !isUploading">
			<img [src]="imagePreviewUrl" class="branding--ad-preview--image" />
		</div>
		<cass-indeterminate-circular-progress-indicator *ngIf="isUploading"></cass-indeterminate-circular-progress-indicator>
	</div>
	<mat-divider></mat-divider>
	<div mat-dialog-actions>
		<div class="action-button-container">
			<div>
				<button *ngIf="imagePreviewUrl" mat-stroked-button (click)="reupload()">{{ 'ORDER_BASKET.MATERIAL_PREVIEW_DIALOG.ACTION_BUTTON_LABELS.RE_UPLOAD' | translate }}</button>
				<button *ngIf="imagePreviewUrl" mat-stroked-button (click)="downloadHires()">{{ 'ORDER_BASKET.MATERIAL_PREVIEW_DIALOG.ACTION_BUTTON_LABELS.DOWNLOAD_HIRES' | translate }}</button>
			</div>
			<button mat-button (click)="closeDialog()">{{ 'ACTION_BUTTON_LABELS.CLOSE' | translate }}</button>
		</div>
	</div>
</div>
